import { Component, OnInit } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import * as _ from 'lodash';
import { CreditCardDetails } from 'src/app/models/payment/credit-card-details.model';

@Component({
  selector: 'app-mw-card-payment-dialog',
  templateUrl: './mw-card-payment-dialog.component.html',
  styleUrls: ['./mw-card-payment-dialog.component.scss']
})
export class MwCardPaymentDialogComponent implements OnInit {
  public creditCardDetails = new CreditCardDetails();
  public expiryMonths: Array<string> = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  public expiryYears: Array<string> = this.calculateAvailableYears();

  constructor(private dialogRef: DialogRef) { }

  ngOnInit(): void {
  }

  public onOkClick(): void {
    this.dialogRef.close({ details: this.creditCardDetails });
  }

  public onCancelClick(): void {
    this.dialogRef.close();
  }

  public getCardNumberPattern(): string {
    let result = '\\d{16}';

    if (!_.isNil(this.creditCardDetails.cardNumber) && this.creditCardDetails.cardNumber.length > 0 && this.creditCardDetails.cardNumber[0] === '3') {
      result = '\\d{15}';
    }

    return result;
  }

  public onCardNumberChange(): void {
    if (!_.isNil(this.creditCardDetails.cardNumber)) {
      this.creditCardDetails.cardNumber = this.creditCardDetails.cardNumber.replace(/\D/g,'');
    }
  }

  public getCvvNumberPattern(): string {
    let result = '\\d{3}';

    if (!_.isNil(this.creditCardDetails.cardNumber) && this.creditCardDetails.cardNumber.length > 0 && this.creditCardDetails.cardNumber[0] === '3') {
      result = '\\d{4}';
    }

    return result;
  }

  public onCvvNumberChange(): void {
    if (!_.isNil(this.creditCardDetails.cvvNumber)) {
      this.creditCardDetails.cvvNumber = this.creditCardDetails.cvvNumber.replace(/\D/g,'');
    }
  }

  private calculateAvailableYears(): Array<string> {
    const result: Array<string> = [];

    const currentYear = new Date().getFullYear();

    for (let i = 0; i < 6; i++) {
      result.push((currentYear + i).toString().substring(2));      
    }

    return result;
  }
}
